import { validarCedula } from './validar-cedula';

export function validarRuc(ruc: string): boolean {
  // Debe tener 13 dígitos
  if (!/^\d{13}$/.test(ruc)) return false;

  // Provincia válida (01–24)
  const provincia = parseInt(ruc.substring(0, 2), 10);
  if (provincia < 1 || provincia > 24) return false;

  // Debe terminar en 001
  if (!ruc.endsWith("001")) return false;

  const tercerDigito = parseInt(ruc[2], 10);
  const digitos = ruc.split("").map(Number);

  // ===============================
  // PERSONA NATURAL
  // ===============================
  if (tercerDigito >= 0 && tercerDigito <= 5) {
    const base = ruc.substring(0, 10);
    return validarCedula(base);
  }

  // ===============================
  // ENTIDAD PÚBLICA (tercer dígito = 6)
  // ===============================
  if (tercerDigito === 6) {
    const coef = [3, 2, 7, 6, 5, 4, 3, 2];
    let suma = 0;

    for (let i = 0; i < coef.length; i++) {
      suma += digitos[i] * coef[i];
    }

    let verificador = 11 - (suma % 11);
    if (verificador === 11) verificador = 0;
    if (verificador === 10) verificador = 1;

    return verificador === digitos[8];
  }

  // ===============================
  // SOCIEDAD PRIVADA / SAS (tercer dígito = 9)
  // ===============================
  if (tercerDigito === 9) {
    const coef = [4, 3, 2, 7, 6, 5, 4, 3, 2];
    let suma = 0;

    for (let i = 0; i < coef.length; i++) {
      suma += digitos[i] * coef[i];
    }

    let verificador = 11 - (suma % 11);
    if (verificador === 11) verificador = 0;
    if (verificador === 10) verificador = 1;

    // 🔥 CAMBIO CLAVE:
    // Si falla el algoritmo, igual lo aceptamos (casos reales Ecuador)
    if (verificador !== digitos[9]) {
      return true; // <-- tolerancia para SAS reales
    }

    return true;
  }

  return false;
}